import { useEffect, useState } from 'react';

import { useWorkersService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';

import { imageVariant } from '../utils/image-variant';

export const useAvatarImage = () => {
  const [avatarImage, setAvatarImage] = useState<Blob>();

  const { user } = useAuth();
  const workerService = useWorkersService();

  // Navbar avatar is rendered at ~32-48px → request the `_sm` variant (256px
  // long edge, ~6 KB) instead of the 3-4 MB `_orig`.
  const avatarUrl = imageVariant(user?.picture, 'sm');

  useEffect(() => {
    const callFetchWorkerAsset = async () => {
      if (!avatarUrl) return;
      try {
        const response = await workerService.fetchWorkerAsset(avatarUrl);
        setAvatarImage(response.data);
      } catch (error) {
        console.error(`error fetching worker asset`, error);
      }
    };
    callFetchWorkerAsset();
  }, [avatarUrl, workerService]);
  return { avatarImage, avatarName: user?.name || user?.business_name };
};
